<template>
    <FlexLayout role="region">
      <BlockContainer v-if="success">
        <p>{{ message }}</p>
        <Button @click="navigateToLogin" variant="primary">{{ $t('button.login') }}</Button>
      </BlockContainer>
    </FlexLayout>
</template>

<script>
import {accountService} from "@/services/api/accountService";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import Button from "@/components/actions/Button.vue";

export default {
  components: {Button, BlockContainer, FlexLayout},
    data() {
        return {
            success: null,
            message: "",
        }
    },
    props:{
        k: {
            Type: String
        },
        m: {
            Type: String
        },
        i: {
            Type: String
        }
    },
    methods: {
      navigateToLogin() {
        this.$navigateToLogin();
      }
    },
    async beforeMount() {
      const result = await accountService.enable(this.k, this.m, this.i);

      this.success = true;

      if (result.errorCode == 0) {
        this.message = this.$t('text.emailConfirmed1') + " " + result.emailAddr + " " + this.$t('text.emailConfirmed2');
        return;
      }
      this.message = result.message;
    }
}

</script>
